import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/iso-9001.scss';

initMainHeader();
